module.exports = __webpack_public_path__ + "static/media/view_icon.cbb1ec1d.svg";